import type { CustomCSSProperties } from '../types/pbTypes';
import type { PbBackground } from '../types/pbShared';

/**
 * Returns the background settings of a component.
 * @param props
 * @returns CustomCSSProperties
 */

type BackgroundCustomCSSProperties = PbBackground;

export function getBackgroundSettings<T extends BackgroundCustomCSSProperties = BackgroundCustomCSSProperties>(
    props: T,
): CustomCSSProperties {
    return {
        backgroundAttachment: props.backgroundAttachment,
        backgroundColor: props.backgroundColor,
        backgroundPosition: props.backgroundPosition,
        backgroundRepeat: props.backgroundRepeat,
        backgroundSize: props.backgroundSize,
    };
}
